var _defs, _rect, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 300",
    width: 800,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#eaf4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f7fbff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 300,
    rx: 16,
    fill: "url(#h)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 160,
    r: 46,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 150,
    r: 38,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 165,
    r: 44,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 80,
    width: 320,
    height: 160,
    rx: 12,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 110,
    width: 280,
    height: 12,
    rx: 6,
    fill: "#cfe3f7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 130,
    width: 240,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 148,
    width: 260,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 166,
    width: 200,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTeam);
export default __webpack_public_path__ + "static/media/hero-team.05d8e5454fcdcc7a0e016d1bb8ce4c34.svg";
export { ForwardRef as ReactComponent };